// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('base.articlecollections', {
        url: '/articlecollections',
        views: {
            'baseList': {
            templateUrl: 'main/base/articlecollections/articlecollections.tpl.html',
            controller: 'ArticleCollectionsController as vm'
        }},
        resolve: {
            collections: collectionsResolver
        }
    });
}

// @ngInject
function collectionsResolver(ArticleCollectionsApiService) {
    return ArticleCollectionsApiService.listAllArticleCollections();
}

// @ngInject
function ArticleCollectionsController($rootScope, $state, $scope, collections, ArticleCollectionsApiService, loadSpinnerService) {
    var vm = this;

    //Properties
    vm.currentUser = $rootScope.currentUser;
    vm.collections = collections;
    vm.selectedCollectionId = 0;
    vm.searchTerm = '';
    vm.currentPage = 1;

    //Methods
    vm.searchTermChange = searchTermChange;
    vm.getFullDate = getFullDate;

    activate();

    function activate() {
        $scope.$watch(function() { return $state.params.collectionId; }, function(newValue, oldValue) {
            vm.selectedCollectionId = parseInt($state.params.collectionId,10);
        });
        $rootScope.$on('ArticleCollection.Inserted', function(event, response) {
        });
        $rootScope.$on('ArticleCollection.Updated', function(event, response) {
        });
        $rootScope.$on('ArticleCollection.Deleted', function(event, response) {
        });
        $rootScope.$on('ArticleCollection.Changed', function(event, response) {
            loadCollections();
        });
    }

    function loadCollections() {
        loadSpinnerService.start('mainSpinner');
        ArticleCollectionsApiService.listAllArticleCollections().then(function(response) {
            vm.collections = response;
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner',{force: true});
        });
    }

    function searchTermChange() {
        vm.currentPage = 1;
        loadCollections();
    }

    function getFullDate(date) {
        var year = new Date(date).getFullYear();
        var month = zeroFill(new Date(date).getMonth() + 1, 2);
        var day = zeroFill(new Date(date).getDate(), 2);

        return '' + year + '-' + month + '-' + day;
    }
    function zeroFill(number, width)
    {
        width -= number.toString().length;
        if (width > 0)
        {
            // eslint-disable-next-line wrap-regex
            return new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number;
        }
        return number + ''; // always return a string
    }
}

angular
    .module('base.articlecollections', ['articlecollections.api', 'articlecollections.articlecollection'])
    .config(stateConfig)
    .controller('ArticleCollectionsController', ArticleCollectionsController);
